export default {
  //method 方法 ，url路由地址，params参数（json格式），port默认为主要服务地址
  https(method, url, params, port = "main") {
    method = method.toLowerCase();
    if (url.indexOf("https://") < 0 && url.indexOf("http://") < 0) {
      url = this.envConfig[port] + url;
      // url = "https://trainingapi.itolearn.com" + url;
    }
    params = params || {};
    if (port == "aiApi") {
      params.platform = sessionStorage.getItem("systemName");
    }
    if (location.host.indexOf("crs.itolearn") >= 0 && this.envConfig["main"].indexOf("trainingapi") < 0) {
      const pathname = location.pathname.replace(/\//g, "") || "pc";
      if (pathname == "mb") {
        this.func.toast("text", "环境参数错误");
      } else {
        this.func.message("error", "环境参数错误");
      }
      return;
    }
    if (method == "get" || method == "delete") {
      let newparams = {};
      for (let key in params) {
        if (params[key] !== "" && params[key] !== "null" && params[key] !== "undefined" && params[key] !== undefined && params[key] !== null) {
          newparams[key] = params[key].toString().replace(/(^\s*)|(\s*$)/g, "");
        }
      }
      url = this.func.urlCode(url, newparams);
    }
    return new Promise((resolve, reject) => {
      this.$axios({
        method: method,
        url: url,
        data: params,
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    });
  },
  httpUpload(method, url, params, process, port = "file") {
    method = method.toLowerCase();
    if (url.indexOf("https://") < 0 && url.indexOf("http://") < 0) {
      url = this.envConfig[port] + url;
    }
    const formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }
    return new Promise((resolve, reject) => {
      this.$axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'multer/form-data'
        },
        onUploadProgress: (progressEvent) => {
          if (typeof process == "function" && progressEvent.lengthComputable) {
            let percent = parseInt(progressEvent.loaded / progressEvent.total * 100);
            process(percent);
          }
        }
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    });
  },
  httpDownload(method, url, params, port = "main") {
    method = method.toLowerCase();
    if (url.indexOf("https://") < 0 && url.indexOf("http://") < 0) {
      url = this.envConfig[port] + url;
    }
    if (method == "get" || method == "delete") {
      let newparams = {};
      for (let key in params) {
        if (params[key] !== "" && params[key] !== "null" && params[key] !== "undefined" && params[key] !== undefined && params[key] !== null) {
          newparams[key] = params[key].toString().replace(/(^\s*)|(\s*$)/g, "");
        }
      }
      url = this.func.urlCode(url, newparams);
    }
    return new Promise((resolve, reject) => {
      this.$axios({
        method: method,
        url: url,
        data: params,
        responseType: "blob",
      }).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    });
  },
}



// WEBPACK FOOTER //
// ./src/server/https.js